module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lMFCO"))).then(() => parcelRequire('ikE14'));